import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedDriverUiDriverRoutingModule } from './shared-driver-ui-driver.routing.module';

@NgModule({
  imports: [CommonModule, SharedDriverUiDriverRoutingModule]
})
export class SharedDriverUiDriverModule {}
